<template>
  <v-card class="elevation-1 mb-2">
    <v-toolbar flat dense color="transparent">
      <v-toolbar-title>{{ contactTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        small
        outlined
        v-if="editContact"
        color="pink"
        @click.stop="update(contact)"
        class="mr-2"
      >
        Save
      </v-btn>
      <v-btn
        small
        outlined
        v-if="editContact"
        color="primary"
        @click.stop="disableEdit"
      >
        Cancel
      </v-btn>
      <v-btn
        small
        outlined
        color="primary"
        @click="enableEdit"
        v-if="!editContact && editVisible"
      >
        Edit
      </v-btn>
    </v-toolbar>
    <v-list-item three-line>
      <v-list-item-content>
        <span v-if="!editContact">{{
          contact.first_name + " " + contact.last_name
        }}</span>
        <v-container v-if="editContact">
          <v-row>
            <v-text-field
              label="First name"
              md="6"
              class="name-part"
              v-model="contact.first_name"
              single-line
              flat
              dense
              height="20px"
              :readonly="editContact == false"
            ></v-text-field>
            <v-text-field
              label="Last name"
              md="6"
              class="name-part"
              v-model="contact.last_name"
              single-line
              flat
              dense
              height="20px"
              :readonly="editContact == false"
            ></v-text-field>
          </v-row>
        </v-container>
        <v-list-item-subtitle class="mt-1">E-mail</v-list-item-subtitle>
        <span v-if="!editContact">{{ contact.email }}</span>
        <v-text-field
          v-if="editContact"
          class="name-part"
          v-model="contact.email"
          single-line
          flat
          dense
          height="20px"
          :readonly="editContact == false"
        ></v-text-field>
        <v-list-item-subtitle class="mt-1">Phone</v-list-item-subtitle>
        <span v-if="!editContact">{{
          contact.phone || "No phone number set"
        }}</span>
        <v-text-field
          v-if="editContact"
          class="name-part"
          v-model="contact.phone"
          single-line
          flat
          dense
          height="20px"
          :readonly="editContact == false"
        ></v-text-field>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
export default {
  props: {
    contact: {
      type: Object
    },
    editVisible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      editContact: false
    }
  },
  computed: {
    contactTitle () {
      let title = 'Contact'

      if (this.contact.is_legal_rep) {
        title = 'Legal representative'
      }
      if (this.contact.is_tech_rep) {
        title = 'Technical contact'
      }
      return title
    }
  },
  methods: {
    enableEdit () {
      this.editContact = true
    },
    disableEdit () {
      this.editContact = false
    },
    update (contact) {
      console.log(contact)
      this.$emit('contact-updated', contact)
      this.editContact = false
    }
  }
}
</script>
